import React, { useState } from "react";
import { Phone } from "../../../../core";

const MergePhone: React.FunctionComponent<{
  name: string;
  onUpdate: (numbers: Phone[]) => void;
  contacts: (
    | {
        name: string | undefined;
        numbers: Phone[];
      }
    | undefined
  )[];
}> = (props) => {
  const [phones, setPhones] = useState<Phone[]>([]);
  const onSelect = (num: Phone) => {
    setPhones((prevPhones: Phone[]) => {
      // Check if the selected phone is already in the list
      const phoneExists = prevPhones.some((phone) => phone.phone === num.phone);

      if (phoneExists) {
        // Remove the phone if it's already present
        return prevPhones.filter((phone) => phone.phone !== num.phone);
      } else {
        // Add the phone if it's not present
        return [...prevPhones, num];
      }
    });
  };
  const onPrimaryCheckChange = (num: Phone) => {
    const prevPhones = phones;
    const phoneExists = prevPhones.some(
      (phone) => phone.phone === num.phone && phone?.isPrimary === true
    );
    let phonePrimary = [];
    if (phoneExists) {
      // Remove the phone if it's already present

      phonePrimary = [
        ...prevPhones
          .filter((phone) => phone.phone !== num.phone)
          ?.map((ph) => {
            return {
              isPrimary: false,
              phone: ph.phone,
              phoneType: ph.phoneType,
            };
          }),
        { isPrimary: false, phone: num.phone, phoneType: num.phoneType },
      ];
    } else {
      // Add the phone if it's not present
      phonePrimary = [
        ...prevPhones
          .filter((phone) => phone.phone !== num.phone)
          ?.map((ph) => {
            return {
              isPrimary: false,
              phone: ph.phone,
              phoneType: ph.phoneType,
            };
          }),
        { isPrimary: true, phone: num.phone, phoneType: num.phoneType },
      ];
    }
    setPhones(phonePrimary);
  };
  React.useEffect(() => {
    props?.onUpdate(phones);
  }, [phones]);

  return (
    <>
      {props?.contacts?.map(
        (contact, contactIndex) =>
          contact && (
            <div key={contactIndex} className="contact">
              <div className="row">
                <div className="col-sm-11 left-wrap">
                  <p className="contact-name font-italic">{contact.name}</p>
                  {contact?.numbers.map((num, index) => {
                    // Generate unique id for each radio button and checkbox
                    const radioId = `radio_${props?.name}_${contactIndex}_${index}`;
                    const checkboxId = `checkbox_${props?.name}_${contactIndex}_${index}`;
                    return (
                      <div key={index} className="d-flex mb-1">
                        <div className="contact-details w-100">
                          <span className="number font-sm font-weight-semibold d-flex align-items-center">
                            {num.phone}
                          </span>
                          <span className="type font-sm border-left font-weight-semibold d-flex align-items-center">
                            {num.phoneType}
                          </span>
                        </div>

                        <div className="radio-button d-flex justify-content-between align-items-center">
                          {/* Radio Button */}
                          <div className="checkbox-box border">
                            <input
                              id={radioId}
                              disabled={
                                !phones.some(
                                  (phone) => phone.phone === num.phone
                                )
                              }
                              checked={phones.some(
                                (phone) =>
                                  phone.phone === num.phone &&
                                  phone?.isPrimary === true
                              )}
                              onClick={() =>
                                onPrimaryCheckChange({
                                  isPrimary: true,
                                  phoneType: num?.phoneType,
                                  phone: num?.phone,
                                })
                              }
                              type="radio"
                              name={props.name + "radio"}
                            />
                            <label
                              htmlFor={radioId}
                              className="pl-0 w-100 h-100 justify-content-center"
                              title="Set as Primary"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="10"
                                viewBox="0 0 14 10"
                                fill="none"
                              >
                                <path
                                  d="M10.9306 0.382293L4.86025 6.45808L2.24072 3.88229C1.72802 3.3696 0.897593 3.3696 0.384624 3.88229C-0.128345 4.39499 -0.128071 5.22542 0.384624 5.73839L3.88462 9.23839C4.18759 9.4987 4.52119 9.62448 4.86025 9.62448C5.19931 9.62448 5.53181 9.49629 5.7883 9.23997L12.7883 2.23997C13.301 1.72728 13.301 0.896848 12.7883 0.383879C12.2756 -0.12909 11.4446 -0.126301 10.9306 0.382293Z"
                                  fill="#9CA3AF"
                                />
                              </svg>
                            </label>
                          </div>

                          <div className="ml-2">
                            <input
                              type="checkbox"
                              id={checkboxId}
                              name={props.name + "checkbox"}
                              onChange={() =>
                                onSelect({
                                  isPrimary: false,
                                  phoneType: num?.phoneType,
                                  phone: num?.phone,
                                })
                              }
                              checked={phones.some(
                                (phone) => phone.phone === num.phone
                              )}
                            />
                            <label className="pl-0 ml-1" htmlFor={checkboxId}>
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )
      )}
    </>
  );
};

export default MergePhone;
